import React from 'react';
import { IconPropsDeprecated } from '@umanforge/common';
import { ReactComponent as ArrowUpSVG } from '@common_components/svg/arrowUp.svg';

const ArrowUpIcon: React.FC<IconPropsDeprecated> = ( { className = '', size = 7, onClick } ) => {
  return (
    <span className={`${className} w-${size} h-${size}`} onClick={onClick}>
      <ArrowUpSVG />
    </span>
  );
};

export { ArrowUpIcon };
